<clr-modal [clrModalOpen]="open" (clrModalOpenChange)="$event ? null : close()" [clrModalSize]="'lg'">
  <h3 class="modal-title">New apps group</h3>
  <div class="modal-body">
    <p class="intro">Start with the way you recognise its members. You can mix the three ways later.</p>

    @if (open) {
      <form clrForm clrLayout="vertical" id="new-apps-group-form" (ngSubmit)="submit()">
        <div class="clr-row">
          <div class="clr-col-md-6">
            <div class="clr-form-control">
              <label for="new-group-name" class="clr-control-label">Name</label>
              <div class="clr-control-container" [class.clr-error]="submitted && error != undefined">
                <div class="clr-input-wrapper">
                  <input id="new-group-name" name="name" class="clr-input" [(ngModel)]="name" placeholder="e.g. web_front"
                         autocomplete="off" [attr.aria-invalid]="submitted && error != undefined" autofocus>
                  <cds-icon class="clr-validate-icon" shape="exclamation-circle" status="danger" aria-hidden="true"></cds-icon>
                </div>
                @if (submitted && error) {
                  <span class="clr-subtext" role="alert">{{ error }}</span>
                }
              </div>
            </div>
          </div>
          <div class="clr-col-md-6">
            <clr-select-container>
              <label for="new-group-file">In the file</label>
              <select clrSelect id="new-group-file" name="file" [(ngModel)]="file" [disabled]="files.length == 0">
                @for (option of files; track option) {
                  <option [value]="option">{{ option }}</option>
                }
              </select>
            </clr-select-container>
          </div>
        </div>

        <fieldset class="ways-section">
          <legend class="clr-control-label">How do you recognise its members?</legend>
          <div class="clr-row">
            @for (option of ways; track option.key) {
              <div class="clr-col-md-4">
                <label class="card clickable way" [class.selected]="option.key == way" [for]="'new-group-way-' + option.key">
                  <div class="card-block">
                    <div class="way-title">
                      <input type="radio" class="clr-radio" name="way" [id]="'new-group-way-' + option.key"
                             [value]="option.key" [(ngModel)]="way">
                      <cds-icon [attr.shape]="option.icon" size="20"></cds-icon>
                      <span class="card-title">{{ option.title }}</span>
                    </div>
                    <p class="card-text">{{ option.text }}</p>
                  </div>
                  <div class="card-footer">
                    <span class="example-label">For example</span>
                    <code class="example">{{ option.example }}</code>
                    <span class="example-note">{{ option.exampleNote }}</span>
                  </div>
                </label>
              </div>
            }
          </div>
        </fieldset>
      </form>

      <clr-alert [clrAlertType]="'info'" [clrAlertClosable]="false" [clrAlertLightweight]="true">
        <clr-alert-item>
          <span class="alert-text">{{ currentWay.hint }}</span>
        </clr-alert-item>
      </clr-alert>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="close()">Cancel</button>
    <button type="submit" form="new-apps-group-form" class="btn btn-primary">{{ currentWay.cta }}</button>
  </div>
</clr-modal>
